export class DmsSharingEntityResource {
  elementId: number;
  fiscalYearId: number;
  fiscalYear: number;
}
